import {RetailPrice} from "../accounting/Purchasable";
import {makeSensitive, Sensitive} from "../common/Sensitive";
import {Money} from "../accounting/Finance";
import {WorkingHours} from "../timesheet/WorkingHours";

export interface ProjectReportBudget extends RetailPrice  {
    plannedPurchasePrice: Sensitive<Money>
    contractorPurchasePrice: Sensitive<Money>
    plannedManHours: Sensitive<WorkingHours>
    internalRetailPrice: Sensitive<Money>
    contractedRetailPrice: Sensitive<Money>
    optionalRetailPrice: Sensitive<Money>
    optionalInternalRetailPrice: Sensitive<Money>
    optionalContractedRetailPrice: Sensitive<Money>
    additionCostRetailPrice: Sensitive<Money>
    retailPriceInclAdditionalCost: Sensitive<Money>
    optionalRetailPriceInclAdditionalCost: Sensitive<Money>
    optionalAdditionCostRetailPrice: Sensitive<Money>
}

export const projectReportBudgetBase: ProjectReportBudget = {
    plannedPurchasePrice: makeSensitive( 0 ),
    contractorPurchasePrice: makeSensitive( 0 ),
    plannedManHours:  makeSensitive( 0 ),
    internalRetailPrice:  makeSensitive( 0 ),
    contractedRetailPrice:  makeSensitive( 0 ),
    optionalRetailPrice:  makeSensitive( 0 ),
    optionalInternalRetailPrice:  makeSensitive( 0 ),
    optionalContractedRetailPrice:  makeSensitive( 0 ),
    retailPrice:  makeSensitive( 0 ),
    additionCostRetailPrice: makeSensitive( 0 ),
    retailPriceInclAdditionalCost: makeSensitive( 0 ),
    optionalRetailPriceInclAdditionalCost: makeSensitive( 0 ),
    optionalAdditionCostRetailPrice: makeSensitive( 0 ),
}